// removed by extract-text-webpack-plugin
module.exports = {"publicsection":"wmf-1FvQFohe","publlictitle":"wmf-2ouyTw-5","required":"wmf-3NQAPFpI","informationtitle":"wmf-33eedSsr","titles":"wmf-3HeYSorC","skustyle":"wmf-197s3v02"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/commoditymanagementadd/commodity-management-add.module.less
// module id = 613
// module chunks = 0